import React from 'react';
import SurveyTab from './SurveyTab';

const BrandSurveyTab = () => {
  return (
    <SurveyTab 
      module="brand"
      title="Brand Surveys"
      description="Complete brand-related surveys to help us understand your perspective on our brand and products."
    />
  );
};

export default BrandSurveyTab; 